import { ConstanteGlobal } from "../config/constanteGlobal";
import { FiltroBasico } from "../models/basico";
import { ModeloSopIndustrialPlant } from "../models/sopIndustrialPlant";
import { Repositorio } from "./repositorio";

export class FiltroSopBusinesUnit extends FiltroBasico<ModeloSopIndustrialPlant> implements Partial<ModeloSopIndustrialPlant> {
  
}

export class RepositorioSopIndustrialPlant extends Repositorio<ModeloSopIndustrialPlant> {
  constructor() {
    super(ConstanteGlobal.SOP_INDUSTRIAL_PLANT);
  }
}
